import AdminVerwaltung from "../Pages/Admin_Users/Admin_Verwaltung";
import CreateAdmin from "../Pages/Admin_Users/Create_Admin";
import { Navigate } from "react-router";

const role=localStorage.getItem("role")

export const AdminUserRoutes = [
  {
    path: 'AdminVerwaltung',
    element: role !== 'manager' ? <Navigate to="/" replace /> : <AdminVerwaltung /> 
  },
  {
    path: 'AdminVerwaltung/CreateAdmin/',
    element: role !== 'manager' ? <Navigate to="/" replace /> : <CreateAdmin />  
  },
  {
    path: 'AdminVerwaltung/EditAdmin/:id',
    element: role !== 'manager' ? <Navigate to="/" replace /> : <CreateAdmin /> 
  },
  ] 